/**
 * store，所有状态注册
 */
/* eslint-disable */
import modalState from "./modalStateModule.js";
import gameState from "./gameStateModule.js";
import services from "./services/servicesModule.js";
import questionListPage from "./knowlege/questionListModule.js";
import questionEdit from "./questionEdit/questionEditModule.js";
import formManagePage from "./form/formManageModule.js";
import personnelManage from "./personnel/personManageModule.js";
import formEdit from "./form/formEditModule.js";
import questionCluster from "./cluster/clusterManageModule.js";
import sensitiveWords from "./sensitiveWords/sensitiveWordsModule.js";
import materialLibraryPage from './materialLibrary/materialLibraryModule'

export default {
    namespaced: true,
    modules: {
        modalState,
        gameState,
        services,
        questionListPage,
        questionEdit,
        formManagePage,
        personnelManage,
        formEdit,
        questionCluster,
        sensitiveWords,
        materialLibraryPage
    }
};
